import {Component, EventEmitter, forwardRef, Input, OnChanges, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {Tools} from "linkurious-shared";

const UI_RADIO_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => RadioComponent),
  multi: true
};

@Component({
  selector: 'radio',
  template: `<div class="radio__wrapper">
  <input type="radio"
         [(ngModel)]="radio_option"
         [name]="name"
         [value]="value"
         [checked]="checked"
         [disabled]="disabled"
         (change)="emitChange()">
  <span class="radio_button--fake"></span>
</div>

`,
  styles: [`.radio__wrapper{position:relative;display:flex;align-items:center}.radio__wrapper input{position:absolute;opacity:0;cursor:pointer;top:0;margin:0;width:16px;height:16px;z-index:2}.radio__wrapper input:disabled{cursor:default}.radio__wrapper input:disabled~.radio_button--fake{opacity:.3}.radio__wrapper input:hover:not(:disabled)~.radio_button--fake{border-color:#0081e3}.radio__wrapper input:checked~.radio_button--fake{border-color:#0081e3;background:#fff}.radio__wrapper input:checked~.radio_button--fake:after{display:block;background:#0081e3}.radio__wrapper .radio_button--fake{position:relative;display:block;height:14px;width:14px;background-color:#fff;border:1px solid #0081e3;border-radius:50%;transition:all ease-in-out .3s}.radio__wrapper .radio_button--fake:after{content:"";position:absolute;display:none;top:3px;left:3px;width:8px;height:8px;border-radius:50%;background:#fff}`],
  providers: [UI_RADIO_CONTROL_VALUE_ACCESSOR]
})
export class RadioComponent implements ControlValueAccessor, OnChanges {

  @Input('name') name: string;
  @Input('value') value: any;
  @Input('checked') checked: boolean;
  @Input('disabled') disabled: boolean;

  @Output('trigger') trigger: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}

  ngOnChanges() {
    if( Tools.isDefined(this.checked) ) {
      this.value = this.checked;
      this.radio_option = this.checked;
    }
  }

  private onTouchedCallback: () => void = () => {};
  private onChangeCallback: (_: any) => void = () => {};

  private _radio_option: any;

  set radio_option(opt: any) {
    if(opt && opt !== '') {
      this._radio_option = opt;
    }
    this.onChangeCallback(opt);
  }

  get radio_option() {
    return this._radio_option;
  }

  public emitChange(){
    this.trigger.emit();
  }

  writeValue(obj: any): void {
    if (obj && obj !== '') {
      this.radio_option = obj;
    }
  }

  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

}
